import { Injectable } from '@angular/core';
import {
  CacheConstant,
  UserProperty,
  AccountProperty
} from '../constants/app.constant';
import { HttpService } from './http/http.service';
import { ParmedApiService as ParmedApi } from '../api/parmed-api.service';
import { AppUtilService } from '../utils/app-util.service';
import { Subject } from 'rxjs';
import { AppCacheService } from './cache/app-cache.service';
import { execute } from '../../modules/products/products.service-helper';
import { Configuration, AppConfigService } from './init/app-config.service';
import { Observable } from 'rxjs';
import { PublisherService } from './publisher.service';
import { HttpHeaders } from '@angular/common/http';
import { Console } from 'console';

@Injectable()
export class UserService {
  /***************Constructor***************/
  constructor(private http: HttpService, private api: ParmedApi, private cacheService: AppCacheService, private configService: AppConfigService) {}
  /***************Constructor***************/

  /***************Event Publisher***************/
  private accountChangedSource = new Subject<boolean>();
  accountChanged$ = this.accountChangedSource.asObservable();
  /***************Event Publisher***************/

  /***************Helper Methods***************/
  getPromotions(buid): Observable<any>{
    const request = {
      categoryTypeId:1000,
      buId: buid
    };
    return this.http.post(this.api.Config.GET_PROMOTION_URL, request, { headers: { ignoreLoadingBar: '' }});
  }

  getPromotionDetail(request): Observable<any>{
    return this.http.post(this.api.Config.GET_CATEGORY_ITEM_URL, request);
  }
  getParmedCategories(buid): Observable<any>{
    const request = {
      categoryTypeId:1001,
      buId: buid
    };
    return this.http.post(this.api.Config.GET_PROMOTION_URL, request, { headers: { ignoreLoadingBar: '' }});
  }

  getSubscription(buid): Observable<any>{
    const request = {
      categoryTypeId:1011,
      buId: buid
    };
    //return this.http.post(this.api.Config.GET_PROMOTION_URL, request, { headers: { ignoreLoadingBar: '' }});
    
    // Uncomment the below line when product API is ready
    return this.http.post(this.api.Product.GET_SUBSCRIPTION_URL, request, { headers: { ignoreLoadingBar: '' }});
  }

  getSubscriptionDetail(request): Observable<any>{
    //return this.http.post(this.api.Config.GET_CATEGORY_ITEM_URL, request);

    // Uncomment the below line when product API is ready
    return this.http.post(this.api.Product.GET_SUBSCRIPTION_ITEMS_URL, request);
  }

  getProperty(propertyName: UserProperty) {
    let value = null;
    const userDetails = this.getAuthUserDetails();

    if (propertyName && userDetails) {
      value = userDetails[propertyName];
    }

        return value;
  }

  updateProperty(propertyName: UserProperty, propertyValue: any) {
    if (propertyName && propertyValue !== undefined) {
      const userDetails = this.getAuthUserDetails();
      userDetails[propertyName] = propertyValue;
      this.cacheService.set(CacheConstant.User_Auth_Detail, userDetails);
    }
  }

  getDefaultAccount() {
    let defaultAccount: any = {};
    const userDetails = this.getAuthUserDetails();
    //console.log(userDetails);
    console.log("DefaultShiptoNum:", UserProperty.DefaultShiptoNum);
    if (userDetails && userDetails[UserProperty.DefaultShiptoNum]) {
      defaultAccount = this.getFilteredAccount(
        AccountProperty.AccountShipToNum,
        userDetails[UserProperty.DefaultShiptoNum],
        userDetails[UserProperty.UserCustomerRef]
      );
    }

    return defaultAccount;
  }

  getCaseData() {
    return {
      caseAlert: this.cacheService.get(CacheConstant.Static_Data).messages.find(msg =>msg.messageId === 'ECODE-01').messageDesc,
      showCaseAlert: (this.cacheService.get(CacheConstant.Env_Properties).theme === 'Major')
    };
  }

  getDefaultAccountMasterData() {
    const defaultAccountNumber = this.getProperty(
      UserProperty.DefaultShiptoNum
    );
    const accounts = this.getProperty(UserProperty.Accounts) as Array<any>;
    return this.getFilteredAccount(
      AccountProperty.AccountNum,
      defaultAccountNumber,
      accounts
    );
  }

  getDefaultAccSoldtoShipToObj() {
    const defaultAccount = this.getDefaultAccount();
    console.log(defaultAccount);
    return {
      shipToNum: defaultAccount.accountShipToNum,
      soldToNum: defaultAccount.accountSoldToNum
    };
  }

  canOrder() {
    const defaultAccount = this.getDefaultAccount();
    const defaultAccountMasterData = this.getDefaultAccountMasterData();
    const hasSoldToAccCreditBlock = this.hasSoldToAccCreditBlock();
    const isCreditAvailable = AppUtilService.cache.get(CacheConstant.Is_Credit_Available);
    return (
      defaultAccount[AccountProperty.CanOrderFlag] &&
      defaultAccountMasterData[AccountProperty.CreditBlock] === 0 &&
      !hasSoldToAccCreditBlock &&
      isCreditAvailable
    );
  }

  canPayInvoice() {
    return this.getDefaultAccount().canPayFlg;
  }

  canOrderMajor() {
    return this.getDefaultAccount().canOrderFlg;
  }

  accessDSCSA() {
    return this.getDefaultAccount().dscsaFlg;
  }

  canSearch() {
    const defaultAccount = this.isAssociationExists();
    return defaultAccount !== null && defaultAccount !== undefined && defaultAccount.userCustomerXrefs.length > 0;
  }


  isAssociationExists() {
    const defaultAccount = this.cacheService.get(CacheConstant.User_Auth_Detail);
    return(defaultAccount);
  }

  /***************Helper Methods***************/

  /***************Service Methods***************/

  get() {
    return this.http.post<any>(this.api.Idm.USER_DETAIL_URL, null);
  }

  getAccounts(userDetailNum: any) {
    const request = {
      userDetailNum: userDetailNum
    };
    return execute(this.http, this.api.User.GET_ACCOUNTS_URL, request, undefined, this.configService);
  }

  saveDefaultAccount(saveRequest: any) {
    saveRequest = Object.assign(
      saveRequest,
      this.getDefaultAccSoldtoShipToObj()
    );
  
    return execute(this.http, this.api.Idm.SAVE_DEFAULT_ACCOUNT_URL, saveRequest, undefined, this.configService);
  }

  saveAccountSettings(request: any) {
    return this.http.post(this.api.User.SAVE_ACCOUNT_SETTINGS_URL, request);
  }

  saveDisablePromotionPopUp() {
    return this.http.post<any>(this.api.User.DISABLE_PROMOTIONPOPUP_URL, null);
  }

  getLastRepInitChatTime(userId: string) {
    const defaultOptions = AppUtilService.getHttpDefaultOptions();
    defaultOptions.headers['Accept'] = 'application/json';

    return this.http.get(
      this.api.User.LAST_REPINIT_TIME_URL + userId,
      defaultOptions
    );
  }

  updateLastRepInitChatTime(userId: string) {
    const defaultOptions = AppUtilService.getHttpDefaultOptions();
    defaultOptions.headers['Accept'] = 'application/json';

    return this.http.put(
      this.api.User.LAST_REPINIT_TIME_URL + userId,
      defaultOptions
    );
  }

  getMaintanenceData() {
    let option = this.createRequestOptions();
    this.http
      .get(this.api.Config.GET_SERVER_METAINFO_URL + "/" + this.cacheService.get(CacheConstant.Env_Properties).buId, {
        headers: option
      })
      .subscribe((res: any) => {
        if (res.appDown) {
          PublisherService.notifyCheckForMaintenance({ isAppDown: true });
        }
      });
  }


  /***************Service Methods***************/

  /***************Private Methods***************/

  private getAuthUserDetails() {
    return this.cacheService.get(CacheConstant.User_Auth_Detail);
  }

  private getFilteredAccount(accountPropertyName, accountNumber, accounts) {
    let account: any = {};

    if (accounts && accounts.length > 0) {
      const filteredAccounts = accounts.filter(
        acc => acc[accountPropertyName] === accountNumber
      );
      //TODO: by default first account is selected if matching mutiple accounts with
      account = filteredAccounts.length > 0 ? filteredAccounts[0] : account;
    }

    return account;
  }

  private hasSoldToAccCreditBlock() {
    let creditBlock = true;
    const defaultAccount = this.getDefaultAccount();

    if (defaultAccount) {
      const soldToAccount = this.getFilteredAccount(
        AccountProperty.AccountNum,
        defaultAccount[AccountProperty.AccountSoldToNum],
        this.getProperty(UserProperty.Accounts)
      );

      creditBlock =
        !soldToAccount || soldToAccount[AccountProperty.CreditBlock] === 1;
    }

    return creditBlock;
  }

  private createRequestOptions() {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-api-key": this.configService.get(
        Configuration.API_KEY
      )
    });
    return headers;
  }

  /***************Private Methods***************/
}
